import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress } from '@mui/material'
export interface ButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'text'
  size?: 'small' | 'medium' | 'large'
  loading?: boolean
  fullWidth?: boolean
}

const Button = ({ 
  variant = 'primary', 
  size = 'medium', 
  loading = false, 
  fullWidth = false,
  children,
  disabled,
  ...props 
}: ButtonProps) => {
  const getVariant = () => {
    switch (variant) {
      case 'primary':
        return 'contained'
      case 'secondary':
        return 'contained'
      case 'outline':
        return 'outlined'
      case 'text':
        return 'text'
      default:
        return 'contained'
    }
  }

  const getColor = () => {
    switch (variant) {
      case 'primary':
        return 'primary'
      case 'secondary':
        return 'secondary'
      case 'outline':
        return 'primary'
      case 'text':
        return 'primary'
      default:
        return 'primary'
    }
  }

  return (
    <MuiButton
      variant={getVariant()}
      color={getColor()}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
      {...props}
    >
      {children}
    </MuiButton>
  )
}

export default Button
